@if (orderDetails(); as details) {
  <div class="max-w-6xl mx-auto p-6 min-h-screen">
    <h1
      class="md:text-2xl text-xl font-semibold text-gray-900 mb-6 flex items-center gap-2"
    >
      <sham-i-arrow-line-left class="md:hidden" (click)="goToBack()" />
      <span class="hidden md:flex">{{ 'order' | translate }}</span>
      {{ details.orderNumber }}
    </h1>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
      <div class="lg:col-span-2">
        <div class="md:border md:border-[#E6E6E6] rounded-lg p-0 md:p-6 space-y-8">
          @for (
            sellerOrder of details.sellerOrders;
            track sellerOrder.sellerOrderId;
            let firstStore = $first
          ) {
            <div
              class="border border-[#E6E6E6] rounded-xl md:border-0 shadow-sm md:shadow-none p-4 md:p-0"
              [class.border-t]="!firstStore"
              [class.border-[#E6E6E6]]="!firstStore"
              [class.pt-6]="!firstStore"
            >
              <div
                class="hidden md:flex flex-col md:flex-row md:items-center md:justify-between border-b border-[#E6E6E6] pb-3 mb-4 gap-3"
              >
                <!-- product/store info -->
                <div class="flex items-center gap-3 order-2 md:order-1">
                  <div
                    class="w-8 h-8 rounded-full overflow-hidden border border-[#E6E6E6] shrink-0 bg-white"
                  >
                    <img
                      [src]="getImageUrl(sellerOrder.sellerStoreLogoUrl)"
                      [alt]="sellerOrder.sellerStoreName"
                      class="w-full h-full object-cover"
                    />
                  </div>

                  <!-- <h2 class="text-sm font-medium text-[#114455]">{{ store.storeName }}</h2> -->
                  <h2 class="text-sm font-medium text-[#114455]">
                    {{ sellerOrder.sellerStoreName }}
                  </h2>

                  <button
                    (click)="goToSellerProfile(sellerOrder.sellerId)"
                    class="hidden md:inline-flex bg-[#2187AB] text-[#FEFEFE] text-xs px-2.5 py-0.5 rounded-xs font-medium hover:bg-[#1d7da0] transition-colors"
                  >
                    {{ 'view_store' | translate }}
                  </button>
                </div>

                <!-- tracking -->
                <a
                  [routerLink]="['/order-tracking', sellerOrder.sellerOrderId]"
                  class="flex items-center gap-2 text-sm font-medium text-[#A53F64] cursor-pointer order-1 md:order-2"
                >
                  <sham-i-delivery-truck-1 />
                  <span class="underline">{{ 'track_your_order' | translate }}</span>
                </a>
              </div>
              <div class="space-y-6">
                @for (
                  item of sellerOrder.items;
                  track item.sellerOrderItemId;
                  let lastItem = $last
                ) {
                  <div
                    class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-[#E6E6E6] pb-6"
                    [class.border-b-0]="lastItem"
                    [class.mb-0!]="lastItem"
                    [class.pb-0!]="lastItem"
                  >
                    <div class="flex gap-4 flex-1">
                      <div
                        class="w-20 h-20 border border-[#E6E6E6] rounded-md overflow-hidden p-2 flex items-center justify-center shrink-0"
                      >
                        <img
                          [src]="getImageUrl(item.productImageUrl)"
                          [alt]="item.productName"
                          class="max-w-full max-h-full object-contain"
                        />
                      </div>

                      <div class="flex flex-col justify-between py-1 flex-1">
                        <div>
                          <h3 class="text-base font-semibold">
                            {{ item.productName }}
                          </h3>
                          <p class="text-sm text-[#424654] font-normal">
                            {{ getOptionsText(item.options) }}
                          </p>
                        </div>

                        <div class="flex items-center justify-between gap-4 pt-1">
                          <span
                            class="inline-block bg-[#DAE2FF] text-[#0040A1] font-medium text-sm px-2 py-1 rounded"
                          >
                            {{ 'qty' | translate }}: {{ item.quantity }}
                          </span>
                          <span class="text-base font-semibold"
                            >{{ item.subtotal }}
                            {{ details.summary.placedTotalCurrency }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <!-- Customer-refusal outcome UI is pending an approved Figma design.
              @if (refusalOutcomes()[sellerOrder.sellerOrderId]; as refusalOutcome) {
                <div class="mt-5">
                  <sham-customer-refusal-outcome
                    [outcome]="refusalOutcome"
                    view="customer"
                    walletLink="/profile/wallet"
                    (refresh)="loadCustomerRefusalOutcome(sellerOrder.sellerOrderId)"
                  />
                </div>
              }
              -->
              <div class="mt-4 flex gap-3 md:hidden justify-between">
                <!-- store name -->
                <div class="flex items-center gap-3">
                  <div
                    class="w-8 h-8 rounded-full overflow-hidden border border-[#E6E6E6] shrink-0 bg-white"
                  >
                    <img
                      [src]="getImageUrl(sellerOrder.sellerStoreLogoUrl)"
                      [alt]="sellerOrder.sellerStoreName"
                      class="w-full h-full object-cover"
                    />
                  </div>
                  <h2 class="text-xs font-medium text-[#114455]">
                    <!-- {{ store.storeName }} -->
                  </h2>
                </div>

                <!-- track order -->
                <a
                  [routerLink]="['/order-tracking', sellerOrder.sellerOrderId]"
                  class="flex items-center gap-2 text-xs font-medium text-[#A53F64]"
                >
                  <sham-i-delivery-truck-1 />
                  <span class="underline">{{ 'track_your_order' | translate }}</span>
                </a>
              </div>
            </div>
          }
        </div>

        <div class="pt-4 hidden md:block">
          <button
            (click)="goBack()"
            class="px-5 py-2.5 rounded-lg bg-[#F2F2F2] flex items-center gap-2 text-white-darkest text-xl hover:text-black hover:bg-gray-200 transition"
          >
            {{ 'Return to store' | translate }}
          </button>
        </div>
      </div>
      <div class="space-y-6 order-4 lg:order-0">
        <!-- shipping -->
        <div class="border border-gray-100 rounded-lg p-6 space-y-8 shadow-sm">
          <section class="mb-4">
            <div class="flex items-center gap-1 text-[#2187AB] mb-4">
              <sham-i-location-address />
              <h3 class="text-sm font-semibold uppercase tracking-widest">
                {{ 'shipping_to' | translate }}
              </h3>
            </div>

            <p class="font-bold text-sm">{{ details.shippingAddress.fullName }}</p>
            <p class="text-[#424654] text-sm font-normal mt-1 leading-relaxed">
              {{ details.shippingAddress.streetAddress }},
              {{ details.shippingAddress.city }},
              {{ details.shippingAddress.country }}
            </p>
          </section>

          <hr class="mb-4" />
          <section class="mb-0 mt-2">
            <div class="flex items-center gap-2 text-[#2187AB] mb-4">
              <sham-i-payment-success-01 />
              <h3 class="text-sm font-semibold uppercase tracking-widest">
                {{ 'payment_method' | translate }}
              </h3>
            </div>
            <div class="text-[13px] text-gray-900">
              <div class="flex justify-between w-full">
                <p class="text-[#9CA3AF]">{{ 'Payment Method' | translate }}:</p>
                <p class="font-semibold">
                  {{ details.paymentMethod | translate }}
                </p>
              </div>
              <div class="flex justify-between w-full">
                <p class="text-[#9CA3AF]">{{ 'Payment Status' | translate }}:</p>
                <p class="font-semibold">
                  {{
                    details.onlinePayment?.status ??
                      details.summary.billableTotalStatus | translate
                  }}
                </p>
              </div>
              @if (canShowRetryPayment()) {
                <div class="mt-4 flex justify-end">
                  <button
                    type="button"
                    (click)="retryPayment()"
                    [disabled]="isRetryingPayment()"
                    class="inline-flex min-h-10 items-center justify-center rounded-lg bg-[#2187AB] px-4 py-2 text-sm font-medium text-white transition hover:bg-[#1a6d8a] disabled:cursor-not-allowed disabled:bg-[#9FBFCC]"
                  >
                    {{
                      (isRetryingPayment() ? 'Redirecting...' : 'Retry Payment')
                        | translate
                    }}
                  </button>
                </div>
              }
              <!-- <p class="text-xs text-[#424654] font-normal mt-1">Transaction ID: TX-90221</p> -->
            </div>
          </section>
        </div>

        <!-- summary -->
        <div
          class="bg-gradient-to-b from-[#66B2CD] to-[#187799] rounded-lg p-6 text-white shadow-sm border border-[#E6E6E6]"
        >
          <h3 class="font-bold text-lg text-[#FFFFFF] mb-6">
            {{ 'order_summary' | translate }}
          </h3>

          <div class="space-y-4 font-normal text-sm">
            <div class="flex justify-between">
              <span>{{ 'subtotal' | translate }}</span
              ><span
                >{{ details.summary.subTotal }}
                {{ details.summary.placedTotalCurrency }}</span
              >
            </div>
            <div class="flex justify-between">
              <span>{{ 'shipping' | translate }}</span
              ><span
                >{{ details.summary.shippingCost }}
                {{ details.summary.placedTotalCurrency }}</span
              >
            </div>
            <div class="flex justify-between border-b border-[#FFFFFF33] pb-4">
              <span>{{ 'taxes_estimated' | translate }}</span
              ><span>0</span>
            </div>

            <div class="flex justify-between border-b border-[#FFFFFF33] pb-4">
              <span>{{ 'totalDiscount' | translate }}</span
              ><span
                >{{ details.summary.couponDiscountTotal }}
                {{ details.summary.couponDiscountTotalCurrency }}</span
              >
            </div>

            <div class="flex justify-between text-xl font-semibold text-[#FFFFFF]">
              <span>{{ 'Total' | translate }}</span>
              <span
                >{{ details.summary.placedTotal }}
                {{ details.summary.billableTotalCurrency }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
